/* eslint-disable */
export default {
  methods: {
    async getAllSheetsObj(sheetId, allSheets) {
      try {
        if (this.isAuthenticated) {
          const gapic = await this.$gapi.getGapiClient(); // init client
          await new Promise((r) => setTimeout(r, 500)); // wait half second
          const response = await gapic.client.sheets.spreadsheets.values.batchGet(
            {
              spreadsheetId: sheetId,
              ranges: allSheets,
            }
          );
          const sheetInfo = await gapic.client.sheets.spreadsheets.get({
            spreadsheetId: sheetId,
            ranges: allSheets,
          });
          let sheetIds = {};
          sheetInfo.result.sheets.map((sheet) => {
            sheetIds[sheet.properties.title] = sheet.properties.sheetId;
          });
          let sheetsObj = {};
          allSheets.forEach((sheet) => {
            const sheetRegex = new RegExp(sheet + ".*");
            let sheetData = response.result.valueRanges.filter((valueRange) =>
              valueRange.range.match(sheetRegex)
            )[0].values;
            sheetsObj[sheet] = this.createSheetObj(sheetData, sheet, sheetIds);
          });
          this.updateSheetsObj(sheetsObj);
        }
      } catch (err) {
        console.error("getAllSheetsObjError: ", err);
      }
    },
    createSheetObj(sheetData, sheet, sheetIds) {
      // Get Max ID
      const idList = sheetData.map((row, idx) => {
        if (idx != 0) {
          return parseInt(row[0]);
        } else {
          return 0;
        }
      });
      const maxId = Math.max(...idList);
      let sheetObj = {};
      sheetObj["rowKey"] = sheetData[0];
      sheetObj["numOfRecords"] = sheetData.length - 1;
      sheetObj["maxId"] = maxId;
      sheetObj["data"] = [];
      sheetObj["sheetId"] = sheetIds[sheet];
      sheetData.forEach((row, idx) => {
        let singleSheetObj = {};
        if (idx != 0) {
          sheetObj.rowKey.map((key, idx) => {
            singleSheetObj[key] = row[idx];
          });
        }
        sheetObj.data.push(singleSheetObj);
      });
      return sheetObj;
    },
    updateSheetsObj(sheetsObj) {
      this.updateSheetsObjAct(sheetsObj);
    },
    async getEditFormFields(sheetId, editSheets) {
      if (this.isAuthenticated) {
        try {
          const a1notation = "!C2:C";
          const editSheetsRange = editSheets.map((sheet) => {
            return sheet + a1notation;
          });
          const gapic = await this.$gapi.getGapiClient(); // init client
          await new Promise((r) => setTimeout(r, 500)); // wait half second
          const response = await gapic.client.sheets.spreadsheets.values.batchGet(
            {
              spreadsheetId: sheetId,
              ranges: editSheetsRange,
              majorDimension: "COLUMNS",
            }
          );
          editSheets.forEach((sheet) => {
            const sheetRegex = new RegExp(sheet + ".*");
            const editSheetField = response.result.valueRanges.filter((range) =>
              range.range.match(sheetRegex)
            )[0].values[0];
            const payload = {
              state: "lists",
              field: sheet,
              value: editSheetField,
            };
            this.$store.dispatch("edit/updateState", payload);
          });
        } catch (err) {
          console.error(err);
        }
      }
    },
  },
};
